import { render, staticRenderFns } from "./EffectivenessDashboard.vue?vue&type=template&id=1f42a4fa&"
import script from "./EffectivenessDashboard.vue?vue&type=script&lang=js&"
export * from "./EffectivenessDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports